import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw24px =
  'M12.25 2.25C13.7688 2.25003 15 3.48123 15 5V10.7686H17C17.9665 10.7686 18.75 11.5521 18.75 12.5186V21.4961H5.25V12.5186C5.25 11.5521 6.0335 10.7686 7 10.7686H9V5C9 3.48122 10.2312 2.25 11.75 2.25H12.25ZM6.75 19.9961H9.03965V17.9975H10.5396V19.9961H13.4404V17.9975H14.9404V19.9961H17.25V15.6553H6.75V19.9961ZM11.75 3.75C11.0596 3.75 10.5 4.30964 10.5 5V12.2686H7C6.86193 12.2686 6.75 12.3805 6.75 12.5186V14.1553H17.25V12.5186C17.25 12.3805 17.138 12.2686 17 12.2686H13.5V5C13.5 4.30966 12.9403 3.75003 12.25 3.75H11.75Z';
const icons: IconVariations = {
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const FormatPainterIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'formatPainter')) as IconWithRender;

FormatPainterIcon.displayName = 'FormatPainterIcon';
FormatPainterIcon.renderIcon = (props) => <FormatPainterIcon {...props} />;
export default FormatPainterIcon;
